// 第三方组件二开，AI 生成注释，自行辨别参考
// @ts-nocheck
import { Dims, Coords, getElementCoords, isDefaultScrollingElement, getElementDims, isWithinAt } from "./dom";
import { addAppropriateOffset, getCurrentScrollOffset } from "./offset";

export function getViewportHeight(root: Element): number {
  return root.clientHeight;
}

export function getViewportWidth(root: Element): number {
  return root.clientWidth;
}

export function getViewportDims(root: Element): Dims {
  return {
    width: getViewportWidth(root),
    height: getViewportHeight(root)
  }
}

export function getViewportScrollHeight(root: Element): number {
  return root.scrollHeight;
}

export function getViewportScrollWidth(root: Element): number {
  return root.scrollWidth;
}

export function getViewportScrollDims(root: Element): Dims {
  return {
    width: getViewportScrollWidth(root),
    height: getViewportScrollHeight(root)
  }
}

export function getViewportStart(root: Element): Coords {
  if (isDefaultScrollingElement(root)) {
    return {
      x: 0,
      y: 0
    }
  } else {
    return getElementCoords(root);
  }
}

export function getViewportEnd(root: Element): Coords {
  const startCoords: Coords = getViewportStart(root);
  return {
    x: startCoords.x + getViewportWidth(root),
    y: startCoords.y + getViewportHeight(root)
  }
}


export function getViewportScrollStart(root: Element): Coords {
  const curScrollOffset: Coords = getCurrentScrollOffset(root);
  const start: Coords = getViewportStart(root);

  return {
    x: start.x - curScrollOffset.x,
    y: start.y - curScrollOffset.y
  }
}

export function getViewportScrollEnd(root: Element): Coords {
  const startCoords: Coords = getViewportScrollStart(root);
  const { width, height } = getViewportScrollDims(root);
  return {
    x: startCoords.x + width,
    y: startCoords.y + height
  };
}

/**
 * 判断一个元素是否在另一个元素的视窗内
 *
 * @param root 根元素
 * @param element 需要判断的元素
 * @param atPosition 可选参数，元素在根元素中的位置
 * @param needsAdjusting 可选参数，是否需要调整位置
 * @returns 如果元素在视窗内，返回 true；否则返回 false
 */
export function isElementInView(root: Element, element: HTMLElement, atPosition?: Coords, needsAdjusting?: boolean): boolean {
  // 如果 root 或 element 不存在，则返回 false
  if (!root || !element) {
    return false;
  }

  // 如果有传入 atPosition，并且 needsAdjusting 为 true，则调用 addAppropriateOffset 函数计算调整后的位置
  // 否则直接使用传入的 atPosition
  const explicitPosition: Coords | undefined = atPosition && (needsAdjusting ? addAppropriateOffset(root, atPosition) : atPosition)

  // 如果 explicitPosition 不存在，则调用 addAppropriateOffset 函数计算 element 的位置
  const position: Coords | undefined = explicitPosition || addAppropriateOffset(root, getElementCoords(element));

  // 获取 element 的尺寸
  const elementDims: Dims = getElementDims(element);

  // 获取视口起始位置
  const startCoords: Coords | undefined = addAppropriateOffset(root, getViewportStart(root));

  // 获取视口尺寸
  const viewportDims: Dims = getViewportDims(root);

  // 判断 element 是否在视口内
  return isWithinAt(elementDims, viewportDims, position, startCoords);
}

// if directed to scroll to a position which is outside the bounds of the scrolling container, the 
// viewport will stop at the edges of that container. We want to get the coords that the viewport
// will end up when given certain coords
/**
 * 获取滚动视口的位置
 *
 * @param root 根元素
 * @param scrollDestination 滚动目标坐标
 * @returns 滚动后的坐标
 */
export function getScrolledViewportPosition(root: Element, scrollDestination: Coords) {
  // 获取视口尺寸
  const dims = getViewportDims(root);
  // 获取视口滚动起始位置
  const startCoords = getViewportScrollStart(root);
  // 获取视口滚动结束位置
  const endCoords = getViewportScrollEnd(root);

  // 计算最右边界位置
  const rightmost = endCoords.x - dims.width;
  // 计算最下边界位置
  const bottommost = endCoords.y - dims.height;

  // 设置初始滚动目标位置
  let coords: Coords = scrollDestination;

  // 如果滚动目标位置的x坐标小于起始位置，则设置为起始位置
  if (scrollDestination.x < startCoords.x) {
    coords.x = startCoords.x;
  // 如果滚动目标位置的x坐标大于最右边界位置，则设置为最右边界位置
  } else if (scrollDestination.x > rightmost) {
    coords.x = rightmost;
  // 否则，滚动目标位置的x坐标保持不变
  } else {
    coords.x = scrollDestination.x;
  }

  // 如果滚动目标位置的y坐标小于起始位置，则设置为起始位置
  if (scrollDestination.y < startCoords.y) {
    coords.y = startCoords.y;
  // 如果滚动目标位置的y坐标大于最下边界位置，则设置为最下边界位置
  } else if (scrollDestination.y > bottommost) {
    coords.y = bottommost;
  // 否则，滚动目标位置的y坐标保持不变
  } else {
    coords.y = scrollDestination.y;
  }

  // 返回最终的滚动目标位置
  return coords;
}
